import { useMutation } from '@tanstack/react-query'
import Router from 'next/router'
import {
  BodyStyle,
  Doors,
  DriveTrain,
  EngineSize,
  FuelType,
  TransmissionType,
} from '../../../../api-client/enums'
import { placeVehicleForSale } from '../../../../api-client/listing'
import { ROUTES } from '../../../../constants'
import Modal from '../../../../components/modal'
import Loader from '../../../../components/loader'
import { useAuth } from '../../../../contexts/auth'
import Result from './result'
import ManualEntry from './manual-entry'
import NotFound from './not-found'

export const VIEWS = {
  Result: 1,
  ManualEntry: 2,
  NotFound: 3,
}

export default function FindVehicle({ defaultView, vehicle, listingType, onClose }) {
  const [{ userDetails }] = useAuth()

  const { mutate: postVehicle, isLoading: postingVehicle } = useMutation({
    mutationFn: placeVehicleForSale,
    onSuccess: ({ id }) => Router.push(`${ROUTES.VehicleDetails}/${id}`),
  })

  const handleResult = (vehicle) => {
    let decodedBuild = !vehicle
      ? null
      : !vehicle.builds
      ? null
      : vehicle.builds.find(({ trimId }) => trimId === vehicle.trimId)

    postVehicle({
      vin: !vehicle ? '' : vehicle.vin,
      year: !vehicle ? '' : vehicle.year,
      generalDetails: {
        makeId: !vehicle ? '' : vehicle.makeId,
        makeName: !vehicle ? '' : vehicle.makeName,
        modelId: !vehicle ? '' : vehicle.modelId,
        modelName: !vehicle ? '' : vehicle.modelName,
        shortTrimName: !vehicle ? '' : vehicle.shortTrimName,
        trimId: !vehicle ? '' : vehicle.trimId,
        trimName: !vehicle ? '' : vehicle.trimName,
        transmissionType: !!decodedBuild ? decodedBuild.transmissionType : TransmissionType.None,
        transmissionSpeed: !!decodedBuild ? decodedBuild.transmissionSpeed : 0,
        engineSize: !!decodedBuild ? decodedBuild.engineSize : EngineSize.None,
        engineDisplacement: !!decodedBuild ? decodedBuild.engineDisplacement : '',
        bodyStyle: !!decodedBuild ? decodedBuild.bodyStyle : BodyStyle.None,
        doors: !!decodedBuild ? decodedBuild.doors : Doors.None,
        fuelType: !!decodedBuild ? decodedBuild.fuelType : FuelType.None,
        drivetrain: !!decodedBuild ? decodedBuild.drivetrain : DriveTrain.None,
        MPGCity: !!decodedBuild ? decodedBuild.mpgCity : 0,
        MPGHighway: !!decodedBuild ? decodedBuild.mpgHighway : 0,
        VehicleByVIN: vehicle,
        InstalledOptionPackages:
          !decodedBuild || !decodedBuild.optionPackages || decodedBuild.optionPackages.length === 0
            ? []
            : decodedBuild.optionPackages
                .filter(({ isStandard }) => !!isStandard)
                .map(({ description }) => description),
      },
      location: {
        latitude: userDetails.location.lat,
        longitude: userDetails.location.lng,
      },
      listingType,
    })
  }

  const handleResultConfirm = () => {
    handleResult(vehicle)
  }

  const handleResultDeny = () => {
    let bareVehicle = {
      vin: !vehicle ? '' : vehicle.vin,
      year: !vehicle ? '' : vehicle.year,
      makeId: !vehicle ? '' : vehicle.makeId,
      makeName: !vehicle ? '' : vehicle.makeName,
      modelId: !vehicle ? '' : vehicle.modelId,
      modelName: !vehicle ? '' : vehicle.modelName,
    }
    handleResult(bareVehicle)
  }

  let modalContent = null

  if (defaultView === VIEWS.Result) {
    modalContent = (
      <Result vehicle={vehicle} onConfirm={handleResultConfirm} onDeny={handleResultDeny} />
    )
  }

  if (defaultView === VIEWS.NotFound) {
    modalContent = (
      <NotFound
        onSubmit={(details) => {
          handleResult(details)
        }}
      />
    )
  }

  if (defaultView === VIEWS.ManualEntry) {
    modalContent = (
      <ManualEntry
        vehicle={vehicle}
        prePopulate={false}
        onSubmit={(details) => {
          handleResult(details)
        }}
      />
    )
  }

  return (
    <Modal onClose={onClose}>
      {postingVehicle && <Loader delay={500} fullPage />}
      {modalContent}
    </Modal>
  )
}
